// extracted by mini-css-extract-plugin
module.exports = {"commentCarouselImage":"CommentCarouselImage_commentCarouselImage_2vapi","blockList":"CommentCarouselImage_blockList_2ycb1","carouselList":"CommentCarouselImage_carouselList_D9o3k"};